import { render, staticRenderFns } from "./CohortTable.vue?vue&type=template&id=1c7cd613&scoped=true"
import script from "./CohortTable.vue?vue&type=script&lang=js"
export * from "./CohortTable.vue?vue&type=script&lang=js"
import style0 from "./CohortTable.vue?vue&type=style&index=0&id=1c7cd613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7cd613",
  null
  
)

export default component.exports